"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseContent = exports.Base = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _reactDom = require("react-dom");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Mask = require("../Mask");
var _Title = require("../Title");
var _Button = require("../Button");
var _ButtonGroup = require("../ButtonGroup");
var _reactTransitionGroup = require("react-transition-group");
var _close = _interopRequireDefault(require("../../assets/images/close.png"));
var _LocaleProvider = require("../LocaleProvider");
var _context = require("../ConfigProvider/context");
var _common = require("../../constants/common");
var _constants = require("../../utils/constants");
var _useHandleClickOutside = _interopRequireDefault(require("../../hooks/useHandleClickOutside"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Base = function Base(props) {
  var _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    title = props.title,
    _props$maskClosable = props.maskClosable,
    maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
    _props$showCloseIcon = props.showCloseIcon,
    showCloseIcon = _props$showCloseIcon === void 0 ? false : _props$showCloseIcon,
    _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? false : _props$showCloseButto,
    _props$showMask = props.showMask,
    showMask = _props$showMask === void 0 ? true : _props$showMask,
    closeButtonText = props.closeButtonText,
    type = props.type,
    className = props.className,
    titleClassName = props.titleClassName,
    contentClassName = props.contentClassName,
    contentContainerClassName = props.contentContainerClassName,
    children = props.children,
    closeWhenClickOutside = props.closeWhenClickOutside,
    _props$showBoxShadow = props.showBoxShadow,
    showBoxShadow = _props$showBoxShadow === void 0 ? false : _props$showBoxShadow,
    _props$modalContainer = props.modalContainerStyle,
    modalContainerStyle = _props$modalContainer === void 0 ? {} : _props$modalContainer,
    _props$haveContentScr = props.haveContentScrollbar,
    haveContentScrollbar = _props$haveContentScr === void 0 ? false : _props$haveContentScr,
    _props$maskContainerS = props.maskContainerStyle,
    maskContainerStyle = _props$maskContainerS === void 0 ? {} : _props$maskContainerS;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inProp = _useState2[0],
    setInProp = _useState2[1];
  var zIndex = props.zIndex || context.modalZIndex || _common.DefaultModalZIndex;
  var dontUseBodyAsDefaultContainer = context.dontUseBodyAsDefaultContainer;
  var container = props.container || document.body;
  var dontCreatePortal = dontUseBodyAsDefaultContainer && container === document.body;
  var onMaskClick = function onMaskClick(e) {
    var _e$stopPropagation, _props$onMaskClick;
    e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
    (_props$onMaskClick = props.onMaskClick) === null || _props$onMaskClick === void 0 ? void 0 : _props$onMaskClick.call(props);
    if (maskClosable) {
      props.onClose(e);
    }
  };
  (0, _react.useEffect)(function () {
    var _context$eventEmitter;
    if (active) {
      var _context$increaseModa;
      setInProp(true);
      context === null || context === void 0 ? void 0 : (_context$increaseModa = context.increaseModalZIndex) === null || _context$increaseModa === void 0 ? void 0 : _context$increaseModa.call(context);
    }
    context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : _context$eventEmitter.emit('setGlobalModalConfigVisible', active);
    return function () {
      var _context$eventEmitter2;

      // 这里的使用 逻辑 都是 当 visible 变量 为 false 时 返回 null 所以这里监听不到 active 等于 false 的情况
      // 为了解决这个问题 添加逻辑在组件销毁的时候 手动赋值为 false
      context === null || context === void 0 ? void 0 : (_context$eventEmitter2 = context.eventEmitter) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.emit('setGlobalModalConfigVisible', false);
    };
  }, [active]);
  (0, _react.useEffect)(function () {
    var _context$eventEmitter3;
    context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : _context$eventEmitter3.emit('setGlobalModalConfigHide', function () {
      props.onClose();
    });
  }, [props.onClose]);
  return dontCreatePortal ? null : /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('modal'), className) // @ts-ignore
    ,

    style: _objectSpread(_objectSpread({}, modalContainerStyle), {}, {
      zIndex: zIndex
    })
  }, showMask ? /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    unmountOnExit: true,
    appear: active,
    in: inProp,
    timeout: 300,
    classNames: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)("modal-".concat(type, "-mask")))
  }, /*#__PURE__*/_react.default.createElement(_Mask.Mask, {
    active: active,
    onClick: onMaskClick,
    style: maskContainerStyle
  })) : null, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    unmountOnExit: true,
    appear: active,
    in: inProp,
    timeout: 300,
    classNames: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)("modal-".concat(type)))
  }, /*#__PURE__*/_react.default.createElement(BaseContent, {
    title: title,
    type: type,
    showCloseIcon: showCloseIcon,
    showCloseButton: showCloseButton,
    footer: props.footer,
    closeButtonText: closeButtonText,
    titleClassName: titleClassName,
    contentClassName: contentClassName,
    className: contentContainerClassName,
    closeWhenClickOutside: closeWhenClickOutside,
    onClose: props.onClose,
    showBoxShadow: showBoxShadow,
    haveContentScrollbar: haveContentScrollbar
  }, children))), container);
};
exports.Base = Base;
var BaseContent = function BaseContent(props) {
  var title = props.title,
    type = props.type,
    showCloseIcon = props.showCloseIcon,
    showCloseButton = props.showCloseButton,
    closeButtonText = props.closeButtonText,
    titleClassName = props.titleClassName,
    contentClassName = props.contentClassName,
    className = props.className,
    children = props.children,
    closeWhenClickOutside = props.closeWhenClickOutside,
    showBoxShadow = props.showBoxShadow,
    haveContentScrollbar = props.haveContentScrollbar;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var ref = (0, _react.useRef)(null);
  var closeModalWhenClickOutside = function closeModalWhenClickOutside() {
    if (!closeWhenClickOutside) {
      return;
    }
    props.onClose();
  };
  (0, _useHandleClickOutside.default)(ref, closeModalWhenClickOutside);
  var popUpAndScrollbar = haveContentScrollbar && type === 'modal';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)("modal-".concat(type)), className, (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('modal-shadow'), showBoxShadow)),
    ref: ref
  }, showCloseIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)("modal-".concat(type, "-close")),
    onClick: props.onClose
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _close.default
  })), title && /*#__PURE__*/_react.default.createElement(_Title.Title, {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)("modal-".concat(type, "-title")), titleClassName),
    content: title
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(popUpAndScrollbar ? (0, _getPrefixCls.getPrefixCls)("modal-".concat(type, "-have-scrollbar-content")) : (0, _getPrefixCls.getPrefixCls)("modal-".concat(type, "-content")), contentClassName)
  }, children), props.footer ? /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, props.footer) : showCloseButton && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)("modal-".concat(type, "-footer"))
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    type: "primary",
    text: closeButtonText || trans(_constants.MODAL_CLOSE_TEXT),
    className: (0, _getPrefixCls.getPrefixCls)('modal-close-button'),
    onClick: props.onClose
  })));
};
exports.BaseContent = BaseContent;